export default __webpack_public_path__ + "static/嘉宾头像_刘传博-a230677fc6d5fa681876417d593bc2d4.png";